var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-box" },
      [
        _c(
          "el-card",
          {
            staticClass: "box-card",
            attrs: { "body-style": { padding: "20px 20px 0" } },
          },
          [
            _c(
              "div",
              { staticClass: "setting-container" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", _vm._b({}, "el-col", _vm.grid1, false), [
                      _vm._v(" "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      _vm._b({}, "el-col", _vm.grid2, false),
                      [
                        _c(
                          "el-form",
                          {
                            ref: "elForm",
                            attrs: {
                              rules: _vm.rules,
                              "label-width": "280px",
                              size: "medium",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-list" },
                              [
                                _vm.fromData
                                  ? _c("form-create", {
                                      attrs: {
                                        option: _vm.fromData.rule.options,
                                        rule: _vm.fromData.rule,
                                      },
                                      on: { submit: _vm.onSubmit },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }